export enum UserStatus {
  /**
   * Deprecated (historical entries might have it still)
   */
  CREATED = 'CREATED',
  VERIFIED = 'VERIFIED',
  TEMPORARY = 'TEMPORARY'
}
